import {APIService} from '@/services/api.service';
import {AmexProblem} from './build-problem';

export type AmexProblemUpdatePreferences = Pick<AmexProblem, 'origin' | 'destination' | 'profile'>;

// problem needs only this fields set: origin, destination and profile
export async function updateProblemPreferencesApi(
  problemPreferencesUpdate: AmexProblemUpdatePreferences,
  sessionId: string,
): Promise<object> {
  try {
    const resp = await APIService.post<object>(`problem/new-preferences`, problemPreferencesUpdate, {
      params: {
        session_id: sessionId,
      },
    });

    return resp;
  } catch (e) {
    return [];
  }
}
